import { Component, OnInit } from '@angular/core';
import { routerTransition } from "../animations"
import { AuthService } from '../auth.service';

@Component({
  selector: 'leaderboard',
  templateUrl: './leaderboard.component.html',
  styleUrls: ['./leaderboard.component.scss'],
  animations: [routerTransition()],
  host: {'[@routerTransition]': ''}
})
export class LeaderboardComponent implements OnInit {

  public userSubscription;
  public users;

  public currentCategory;
  public currentCallout;
  public scoreIdentifier;

  constructor(private auth: AuthService) { }

  ngOnInit() {
    this.fetchLeaderboard();
  }

  ngOnDestroy() {
    this.userSubscription.unsubscribe();
  }

  public fetchLeaderboard() {
    this.users = [];

    if(this.currentCategory && this.currentCallout) {
      this.scoreIdentifier = this.currentCategory + "Score_" + this.currentCallout;
    }

    else if(this.currentCategory) {
      this.scoreIdentifier = this.currentCategory + "Score";
    }

    else {
      this.scoreIdentifier = 'score';
    }

    this.userSubscription =
      this.auth.getLeaderboard(this.currentCategory, this.currentCallout, 50).subscribe(users => {
        this.users = [];
        for(let i=users.length-1; i>=0; i--) {
          if(users[i][this.scoreIdentifier]) {
            this.users.push(users[i]);
          }
        }
      });
  }

  public handleCategoryChange(event) {
    this.currentCategory = event;
    this.currentCallout = null;
    this.fetchLeaderboard();
  }

  public handleCalloutChange(event) {
    this.currentCallout = event;
    this.fetchLeaderboard();
  }

}



// WEBPACK FOOTER //
// /Users/nicholasgerard/Documents/Quibbl/quibbl/src/app/leaderboard/leaderboard.component.ts